<template>
  <div class="uk-child-width-1-1 uk-grid" data-uk-grid>
    <banners v-if="banners && banners.length" :banners="banners"></banners>
    <div>
      <latest-vehicles v-if="$store.state.auth.user.isAuthenticated"> </latest-vehicles>
    </div>
  </div>
</template>

<script>
import LatestVehicles from '@/components/vehicles/LatestVehicles'
import Banners from '@/components/Banners'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {}
  },
  components: {
    LatestVehicles,
    Banners
  },
  computed: {
    ...mapGetters(['banners'])
  }
}
</script>
